module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921000834_T.06f409da.jpg";